import { Avatar, Button, Divider, Empty, List, message, Popover, Segmented, Spin, Tabs, TabsProps, Tag } from 'antd'
import React, { ReactNode, useEffect, useMemo, useState } from 'react'
import BackIcon from '../../components/icons/BackIcon'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import TopBar from '../components/header/TopBar';
import { GetUserProfile } from '../../API/endpoints/User';
import Cookies from 'js-cookie';
import { getColorByLetter } from '../../common/helpers';
import { PARTNER_INTERESTED, PARTNER_SUITABLE, STATUS_INTEREST_ACCEPTED, STATUS_INTEREST_EXPRESSED, STATUS_INTEREST_RECEIVED, STATUS_INTERESTS_EXPRESSED, STATUS_INTERESTS_RECEIVED, STATUS_OPEN, STATUS_PARTNER_INTEREST_ACCEPTED, STATUS_PARTNER_INTEREST_EXPRESSED, STATUS_PARTNER_INTEREST_SKIPPED, STATUS_PENDING, STATUS_RECOMMENDED, TAB_DOCS, TAB_MESSAGES, TAB_PROFILE, USER_TYPE_ADMIN, USER_TYPE_ORGANIZATION, USER_TYPE_PARTNER } from '../../constants/constants';
import ChinaFlag from '../../components/icons/flags/ChinaFlag';
import HongKongFlag from '../../components/icons/flags/HongKongFlag';
import IndiaFlag from '../../components/icons/flags/IndiaFlag';
import IndonesiaFlag from '../../components/icons/flags/IndonesiaFlag';
import JapanFlag from '../../components/icons/flags/JapanFlag';
import MalasiaFlag from '../../components/icons/flags/MalasiaFlag';
import PhlippinesFlag from '../../components/icons/flags/PhlippinesFlag';
import SingaporeFlag from '../../components/icons/flags/SingaporeFlag';
import SKoreaFlag from '../../components/icons/flags/SKoreaFlag';
import TaiwanFlag from '../../components/icons/flags/TaiwanFlag';
import ThailandFlag from '../../components/icons/flags/ThailandFlag';
import VietnamFlag from '../../components/icons/flags/VietnamFlag';
import AustraliaFlag from '../../components/icons/flags/AustraliaFlag';
import ClockIconSmall from '../../components/icons/ClockIconSmall';
import DollarIcon from '../../components/icons/DollarIcon';
import FacebookIcon from '../../components/icons/FacebookIcon';
import InstagramIcon from '../components/BrandsPartnerComponents/InstagramIcon';
import LinkedinIcon from '../../components/icons/LinkedinIcon';
import TwitterIcon from '../../components/icons/TwitterIcon';
import LinkIcon from '../../components/icons/LinkIcon';
import Detailltem from '../Organization/components/Detailltem';
import Paragraph from 'antd/es/typography/Paragraph';
import PartnerItem from '../../components/PartnerItem';
import PartnerProfile from './components/PartnerProfile';
import PartnerDocs from './components/PartnerDocs';
import Messages from './components/Messages';
import ConfirmModal from './components/ConfirmModal';
import { createBrandRequestPartner, getBrandRequestDetails, getBrandRequestsPartnersByRequestId, getSuitablePartnersByRequestId, updateBrandRequest, updateBrandRequestPartner } from '../../API/endpoints/Discovery';
import FeedbackModal from './components/FeedbackModal';

interface Props {
  type: "partner" | "organization" | "admin"

}
const BrandRequestView = (props: Props) => {

  const { type } = props;

  const navigate = useNavigate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [messageApi, contextHolder] = message.useMessage();

  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [selectedType, setSelectedType] = useState(PARTNER_SUITABLE);
  const [activeTab, setActiveTab] = useState(TAB_PROFILE);

  const [selectedParter, setSelectedPartner] = useState("");

  const [confirmModalData, setConfirmModalData] = useState<any>({
    type: "",
    title: "",
    message: "",
    okText: ""
  })

  const [showFeedbackModal, setShowFeedbackModal] = useState(false)

  const [details, setDetails] = useState<any>({})
  const [statusDetails, setStatusDetails] = useState<any>({})
  const [loading, setLoading] = useState(true);
  const [loadingPartners, setLoadingPartners] = useState(true);
  const [reloadPartners, setReloadPartners] = useState(false);

  // const [partnerList, setPartnerList] = useState([
  //   {
  //     id: "1",
  //     brand_name: "Health First",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Vitamins & Minerals",
  //       "Immune Support & Wellness",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 3,
  //     interestedPartners: 3,
  //     recommendedPartners: 3,
  //     updatedAt: "2025-05-24T10:33:47.515Z",

  //   },
  //   {
  //     id: "2",
  //     brand_name: "SkinEssentials",
  //     location: "Malaysia",
  //     category: "Beauty & Skin",
  //     subCategory: [
  //       "Skin Care",
  //       "Body Care"
  //     ],
  //     suitablePartners: 2,
  //     updatedAt: "2025-05-21T10:33:47.515Z",
  //     status: STATUS_RECOMMENDED,

  //   },
  //   {
  //     id: "3",
  //     brand_name: "Nutri Well",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Sports & Fitness Supplements",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 0,
  //     updatedAt: "2025-05-17T10:33:47.515Z",
  //   },
  //   {
  //     id: "11",
  //     brand_name: "Health First",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Vitamins & Minerals",
  //       "Immune Support & Wellness",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 3,
  //     interestedPartners: 3,
  //     recommendedPartners: 3,
  //     updatedAt: "2025-05-24T10:33:47.515Z",

  //   },
  //   {
  //     id: "12",
  //     brand_name: "SkinEssentials",
  //     location: "Malaysia",
  //     category: "Beauty & Skin",
  //     subCategory: [
  //       "Skin Care",
  //       "Body Care"
  //     ],
  //     suitablePartners: 2,
  //     updatedAt: "2025-05-21T10:33:47.515Z",

  //   },
  //   {
  //     id: "13",
  //     brand_name: "Nutri Well",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Sports & Fitness Supplements",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 0,
  //     updatedAt: "2025-05-17T10:33:47.515Z",
  //   },
  //   {
  //     id: "21",
  //     brand_name: "Health First",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Vitamins & Minerals",
  //       "Immune Support & Wellness",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 3,
  //     interestedPartners: 3,
  //     recommendedPartners: 3,
  //     updatedAt: "2025-05-24T10:33:47.515Z",

  //   },
  //   {
  //     id: "22",
  //     brand_name: "SkinEssentials",
  //     location: "Malaysia",
  //     category: "Beauty & Skin",
  //     subCategory: [
  //       "Skin Care",
  //       "Body Care"
  //     ],
  //     suitablePartners: 2,
  //     updatedAt: "2025-05-21T10:33:47.515Z",

  //   },
  //   {
  //     id: "23",
  //     brand_name: "Nutri Well",
  //     location: "Singapore",
  //     category: "Health Supplement",
  //     subCategory: [
  //       "Sports & Fitness Supplements",
  //       "Weight Management"
  //     ],
  //     suitablePartners: 0,
  //     updatedAt: "2025-05-17T10:33:47.515Z",
  //   },
  // ])

  const [partnerList, setPartnerList] = useState<any[]>([])


  useEffect(() => {
    setUserID(Cookies.get("userID"));

    if (params?.id && Object.keys(userProfile).length > 0) {
      setLoading(true);
      getBrandRequestDetails(params?.id, userProfile?.partnerv2_id).then((res: any) => {
        let data = res?.data || {}
        data.status = data.status == STATUS_OPEN ? STATUS_PENDING : data?.status || undefined;
        data.counts = data?.counts && data?.counts?.length > 0 ? data?.counts[0] : {}
        setDetails(data)
        setStatusDetails(res?.discoveryBrandPartner || {});
        setLoading(false);
      }).catch((err) => {
        console.error('err', err);
        setLoading(false);
        setDetails({});
        setStatusDetails({});
      })
    }
    if (userProfile?.partnerv2_id) {
      setSelectedPartner(userProfile?.partnerv2_id);
    }


  }, [params, userProfile]);

  useEffect(() => {
    if (params?.id && Object.keys(userProfile).length > 0 && !userProfile?.partnerv2_id) {
      setLoadingPartners(true);
      const partnerParam = searchParams.get("partnerID");
      if (selectedType == PARTNER_INTERESTED) {
        getBrandRequestsPartnersByRequestId(
          params?.id, selectedType == PARTNER_INTERESTED
          ? [STATUS_PARTNER_INTEREST_EXPRESSED, STATUS_PARTNER_INTEREST_ACCEPTED]
          : []
        )
          .then((res: any) => {
            const data = res?.data || [];
            setPartnerList(data)
            setSelectedPartner(partnerParam ? partnerParam : prev => data?.length > 0 && !prev ? data[0]?.partner_id : prev)
            setLoadingPartners(false);
          }).catch((err) => {
            console.error('err', err);
            setLoadingPartners(false);
            setPartnerList([]);
          })
      } else {
        if (type == USER_TYPE_ADMIN) {
          getSuitablePartnersByRequestId(
            params?.id
          )
            .then((res: any) => {
              const data = res?.data?.map((item: any) => (
                {
                  partner: item,
                  id: item?.id,
                  partner_id: item?.id
                }
              )) || [];
              setPartnerList(data)
              setSelectedPartner(partnerParam ? partnerParam : prev => data?.length > 0 && !prev ? data[0]?.partner_id : prev)
              setLoadingPartners(false);
            }).catch((err) => {
              console.error('err', err);
              setLoadingPartners(false);
              setPartnerList([]);
            })
        } else {
          setSelectedType(PARTNER_INTERESTED);
        }


      }
    }
  }, [params, selectedType, reloadPartners, userProfile, searchParams])

  useEffect(() => {
    const messageParam = searchParams.get("messageID");
    if (messageParam) {
      setActiveTab(TAB_MESSAGES)
    }
  }, [searchParams])

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);


  const onChangeMenu = (tab: string) => {
    setSelectedType(tab)
    setPartnerList([]);
    setSelectedPartner("")
  }

  const onChangeTab = (tab: string) => {
    setActiveTab(tab);
  }

  const onCancelConfirm = () => {
    setConfirmModalData({
      type: "",
      title: "",
      message: "",
      okText: ""
    })
  }
  const onOkConfirm = () => {
    const req = {
      status: confirmModalData?.type,
      discovery_request_id: details?.id,
      partner_id: userProfile?.partnerv2_id,
      recommended: details?.recommended || false
    }

    createBrandRequestPartner(req).then((res: any) => {
      messageApi.success(`${confirmModalData?.type === STATUS_PARTNER_INTEREST_EXPRESSED ? "Interest expressed" : "Skipped"} successfully`);
      setStatusDetails({
        ...statusDetails,
        status: confirmModalData?.type
      })
      onCancelConfirm();
      if (confirmModalData?.type !== STATUS_PARTNER_INTEREST_EXPRESSED) {
        setShowFeedbackModal(true)
      }
    }).catch((err) => {
      console.error('err', err);
      messageApi.error(`Failed to ${confirmModalData?.type === STATUS_PARTNER_INTEREST_EXPRESSED ? "express interest" : "skip request"}. Please try again!`)
    })
    // // updateBrandRequest(params?.id, req).then((res: any) => {
    //   messageApi.success(`${confirmModalData?.type === STATUS_INTEREST_EXPRESSED ? "Interest expressed" : "Skipped"} successfully`)
    //   onCancelConfirm();
    // }).catch((err) => {
    //   console.error('err', err);
    //   messageApi.error(`Failed to ${confirmModalData?.type === STATUS_INTEREST_EXPRESSED ? "express interest" : "skip request"}. Please try again!`)
    // })
  }


  const confirmExpressInterest = () => {
    setConfirmModalData({
      type: STATUS_PARTNER_INTEREST_EXPRESSED,
      message: (
        <>
          Are you interested in partnering with {details?.brand?.brand_name} for their {details?.Market?.name} market expansion?
          <br />
          <br />
          This will notify the brand and enable further communication and document sharing. Are you sure you want to proceed?
        </>
      ),
      okText: "Yes, I'm Interested",
      title: "Confirm Expression of Interest"
    })
  }

  const confirmSkipRequest = () => {
    setConfirmModalData({
      type: STATUS_PARTNER_INTEREST_SKIPPED,
      message: `Are you sure you want to skip this partnership opportunity with ${details?.brand?.brand_name}?`,
      okText: "Yes, Skip This Request",
      title: "Skip This Request"
    })
  }

  const openLink = (link: string) => {
    if (link) {
      const fullUrl = link.startsWith("http") ? link : `https://${link}`;
      window.open(fullUrl, "_blank", "noopener,noreferrer");
    }
  }



  const flagIcon = useMemo(() => {
    switch (details?.Market?.name) {
      case "China":
        return <ChinaFlag />
      case "Hong Kong":
        return <HongKongFlag />
      case "India":
        return <IndiaFlag />
      case "Indonesia":
        return <IndonesiaFlag />
      case "Japan":
        return <JapanFlag />
      case "Malaysia":
        return <MalasiaFlag />
      case "Philippines":
        return <PhlippinesFlag />
      case "Singapore":
        return <SingaporeFlag />
      case "South Korea":
        return <SKoreaFlag />
      case "Taiwan":
        return <TaiwanFlag />
      case "Thailand":
        return <ThailandFlag />
      case "Vietnam":
        return <VietnamFlag />
      case "Australia":
        return <AustraliaFlag />
      case "Thailand":
        return <ThailandFlag />

      default:
        return <></>
    }
  }, [details])

  const socialMediaLinks = useMemo(() => {
    return details?.brand?.social_media?.map((s: any) => {
      let icon: ReactNode = <></>;
      switch (s?.platform) {
        case "facebook":
          icon = <FacebookIcon />
          break;

        case "instagram":
          icon = <InstagramIcon />
          break;

        case "linkedin":
          icon = <LinkedinIcon />
          break;
        case "twitter":
          icon = <TwitterIcon />
          break;

        default:
          break;
      }
      return (
        <div onClick={() => openLink(s?.url)} className='cursor-pointer hover:scale-110 transition-all' key={s?.id}>
          {icon}
        </div>
      )
    })
  }, [details])

  const marketPlaces = useMemo(() => {
    return details?.brand?.market_place?.length > 2 ? (
      <div>
        {details?.brand?.market_place?.slice(0, 2)?.map((item: any) => (
          <Tag bordered={false}>{item?.platform}</Tag>
        ))}
        <Popover
          trigger="hover"
          placement="bottom"
          content={(
            <Paragraph className='!mb-0 pl-[12px]'>
              <ul className="!mb-0">
                {details?.brand?.market_place?.map((item: any, index: number) => (
                  <li className="text-[13px] font-[500] m-0" key={index}>
                    {item?.platform}
                  </li>
                ))
                }
              </ul>
            </Paragraph>
          )}  >
          <Button type="link" size="small" className="!px-0 leading-[12px] text-[12px] underline">+{details?.brand?.market_place?.length - 2} more</Button>
        </Popover>
      </div>

    ) : (
      details?.brand?.market_place?.map((item: any, index: number) => (
        <Tag bordered={false} key={index}>{item?.platform}</Tag>
      ))
    )
  }, [details])

  const subCategories = useMemo(() => (
    details?.sub_category?.length > 2 ? (
      <div>
        {details?.sub_category?.slice(0, 2)?.map((item: any) => (
          <Tag bordered={false}>{item}</Tag>
        ))}
        <Popover
          trigger="hover"
          placement="bottom"
          content={(
            <Paragraph className='!mb-0 pl-[12px]'>
              <ul className="!mb-0">
                {details?.sub_category?.map((item: any, index: number) => (
                  <li className="text-[13px] font-[500] m-0" key={index}>
                    {item}
                  </li>
                ))
                }
              </ul>
            </Paragraph>
          )}  >
          <Button type="link" size="small" className="!px-0 leading-[12px] text-[12px] underline">+{details?.sub_category?.length - 2} more</Button>
        </Popover>
      </div>

    ) : (
      details?.sub_category?.map((item: any, index: number) => (
        <Tag bordered={false} key={index}>{item}</Tag>
      ))
    )
  ), [details])


  const capabilities = useMemo(() => (
    details?.partner_capabilities?.length > 2 ? (
      <div>
        {details?.partner_capabilities?.slice(0, 2)?.map((item: any) => (
          <Tag bordered={false}>{item}</Tag>
        ))}
        <Popover
          trigger="hover"
          placement="bottom"
          content={(
            <Paragraph className='!mb-0 pl-[12px]'>
              <ul className="!mb-0">
                {details?.partner_capabilities?.map((item: any, index: number) => (
                  <li className="text-[13px] font-[500] m-0" key={index}>
                    {item}
                  </li>
                ))
                }
              </ul>
            </Paragraph>
          )}  >
          <Button type="link" size="small" className="!px-0 leading-[12px] text-[12px] underline">+{details?.partner_capabilities?.length - 2} more</Button>
        </Popover>
      </div>

    ) : (
      details?.partner_capabilities?.map((item: any, index: number) => (
        <Tag bordered={false} key={index}>{item}</Tag>
      ))
    )
  ), [details])

  const channels = useMemo(() => (
    details?.partner_channels?.length > 2 ? (
      <div>
        {details?.partner_channels?.slice(0, 2)?.map((item: any) => (
          <Tag bordered={false}>{item}</Tag>
        ))}
        <Popover
          trigger="hover"
          placement="bottom"
          content={(
            <Paragraph className='!mb-0 pl-[12px]'>
              <ul className="!mb-0">
                {details?.partner_channels?.map((item: any, index: number) => (
                  <li className="text-[13px] font-[500] m-0" key={index}>
                    {item}
                  </li>
                ))
                }
              </ul>
            </Paragraph>
          )}  >
          <Button type="link" size="small" className="!px-0 leading-[12px] text-[12px] underline">+{details?.partner_channels?.length - 2} more</Button>
        </Popover>
      </div>

    ) : (
      details?.partner_channels?.map((item: any, index: number) => (
        <Tag bordered={false} key={index}>{item}</Tag>
      ))
    )
  ), [details])




  const menuOptions = useMemo(() => {
    return [
      {
        label: "Suitable",
        value: PARTNER_SUITABLE
      },
      {
        label: "Interested",
        value: PARTNER_INTERESTED
      }
    ]
  }, [])

  const selectdPartnerDetails = useMemo(() => partnerList?.find((p: any) => p?.partner_id === selectedParter), [partnerList, selectedParter])

  const items: TabsProps['items'] = useMemo(() => {

    let tabs = [
      {
        key: TAB_PROFILE,
        label: 'Profile',
        children: <PartnerProfile
          id={selectedParter}
          data={Object.keys(statusDetails).length > 0 ? statusDetails : selectdPartnerDetails}
          userType={type}
          reloadPartners={() => setReloadPartners(!reloadPartners)}
          updateStatus={(status: string) => {
            setReloadPartners(!reloadPartners)
            setStatusDetails({ ...statusDetails, status: status })
            setDetails({ ...details, status: status })
          }}
        />,
      },
      {
        key: TAB_DOCS,
        label: 'Docs',
        children: <PartnerDocs userProfile={userProfile} request={details} />,
      },
    ];
    if ((selectedType === PARTNER_INTERESTED && !userProfile?.partnerv2_id) || (userProfile?.partnerv2_id && [STATUS_INTEREST_EXPRESSED, STATUS_PARTNER_INTEREST_EXPRESSED, STATUS_INTEREST_ACCEPTED, STATUS_PARTNER_INTEREST_ACCEPTED].includes(statusDetails?.status))) {
      tabs.push({
        key: TAB_MESSAGES,
        label: 'Messages',
        children: <Messages userProfile={userProfile} partner={selectdPartnerDetails || { discovery_request_id: params.id, partner_id: userProfile?.partnerv2_id, partner: userProfile?.partnerv2 }} />,
      })
    }
    return tabs;
  }, [userProfile, details, selectedParter, selectdPartnerDetails, statusDetails, type])

  const backUrl = useMemo(() => {
    switch (type) {
      case USER_TYPE_ADMIN:
        return '/discoverymanagement/org&&admin'

      case USER_TYPE_ORGANIZATION:
        return '/brand-user/discovery'

      case USER_TYPE_PARTNER:
        return '/partner-user/discovery'

      default:
        return '';
    }
  }, [])

  const suitableList = useMemo(() => {
    return partnerList?.map((item: any, index: number) => {
      return (
        <div className='flex items-center gap-x-[12px]'>
          <Avatar shape="square" size={'large'} style={getColorByLetter(item?.brand_name?.charAt(0))}>{item?.brand_name?.charAt(0)}</Avatar>
          <div>
            <p className='mb-[6px] text-[13px] font-[500]'>{item?.brand_name}</p>
            <div className='flex items-center gap-x-[6px]'>
              {flagIcon}
              <p className='text-[12px] text-[#475467] m-0'>{item?.location}</p>
            </div>
          </div>
        </div>
      )
    })
  }, [partnerList])


  const statusTag = useMemo(() => {
    const status = type !== USER_TYPE_PARTNER ? details?.status : statusDetails?.status
    const statusText = status === STATUS_OPEN ? STATUS_PENDING : userProfile?.org_id && status === STATUS_INTEREST_EXPRESSED ? STATUS_INTEREST_RECEIVED : status;
    let color = "warning";

    if (statusText === STATUS_INTEREST_RECEIVED) {
      color = "purple"
    } else if (statusText === STATUS_INTEREST_EXPRESSED || statusText === STATUS_PARTNER_INTEREST_EXPRESSED) {
      color = "blue"
    } else if (statusText === STATUS_INTEREST_ACCEPTED || statusText === STATUS_PARTNER_INTEREST_ACCEPTED) {
      color = "success"
    } else {
      color = "warning"
    }

    return statusText ? <Tag bordered={false} className="capitalize !rounded-[24px] text-[10px] font-[500]" color={color}>{statusText?.replaceAll("_", " ")?.toLowerCase()}</Tag> : <></>
  }, [details, statusDetails, userProfile])


  return (
    <div className='w-full h-full'>
      {contextHolder}
      <TopBar userProfile={userProfile} backUrl={backUrl} title='Back to Discovery' />
      {loading || Object.keys(details)?.length == 0 ? (
        <div className='w-full h-[calc(100vh-49px)] bg-[#F2F4F7] p-[16px] flex flex-col items-center justify-center'>

          {loading ? (
            <Spin />
          ) : (
            <p className='text-gray-600 text-[14px]'>Unabled to fetch details. Please refresh the page.</p>
          )}

        </div>
      ) : (
        <div className='w-full bg-[#F2F4F7] p-[16px] '>
          <div className='bg-white rounded-[8px] flex mb-[16px] p-[14px]'>
            <div className='w-[25%] flex gap-x-[12px] border-r border-[#E4E7EC] pr-[40px]'>
              <Avatar shape="square" size={'large'} style={getColorByLetter(details?.brand?.brand_name?.charAt(0))}>{details?.brand?.brand_name?.charAt(0)}</Avatar>
              <div className='flex flex-col gap-y-[20px]'>
                <div>
                  <div className='flex items-center gap-x-[4px] mb-[6px]'>
                    <p className='m-0 text-[13px] font-[500]'>{details?.brand?.brand_name}</p>
                    {statusTag}

                  </div>
                  <div className='flex items-center gap-x-[6px]'>
                    {flagIcon}
                    <p className='text-[12px] text-[#475467] m-0'>{details?.Market?.name} • {details?.category}</p>
                  </div>
                </div>
                <div className='flex flex-col text-[12px] text-[#475467] gap-y-[14px]'>
                  <div className='flex items-center text-[12px] text-[#475467] gap-x-[4px]'>
                    <div className='flex items-center gap-x-[4px]'>
                      <ClockIconSmall />
                      <p className='text-[12px] text-[#475467] m-0'>{details?.brand?.years_of_operation}</p>
                    </div>
                    •
                    <div className='flex items-center gap-x-[4px]'>
                      <DollarIcon />
                      <p className='text-[12px] text-[#475467] m-0'>{details?.brand?.current_revenue}</p>
                    </div>
                  </div>
                  <div className='flex items-center text-[12px] text-[#475467] gap-x-[4px]'>
                    <div className='flex items-center gap-x-[8px]'>
                      {socialMediaLinks}
                    </div>
                    {details?.brand?.website ? (
                      <>
                        •
                        <div className='flex gap-x-[4px] items-center cursor-pointer' onClick={() => openLink(details?.brand?.website)}>
                          <LinkIcon />
                          <p className='max-w-[170px] truncate text-[12px] m-0 text-[#475467] underline'>{details?.brand?.website}</p>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                  </div>
                </div>

                <div className=''>
                  <p className='text-[#475467] text-[12px] mb-[8px]'>Marketplaces</p>
                  <div className='flex'>
                    {marketPlaces}
                  </div>
                </div>
              </div>
            </div>
            <div className='w-[35%] px-[40px] border-r border-[#E4E7EC] flex-1 flex flex-col gap-y-[20px]'>
              <div className=''>
                <p className='text-[#475467] text-[12px] mb-[8px]'>Sub-categories</p>
                <div className=''>
                  {subCategories}
                </div>
              </div>
              <div className=''>
                <p className='text-[#475467] text-[12px] mb-[8px]'>Capabilities</p>
                <div className='flex'>
                  {capabilities}
                </div>
              </div>
              <div className=''>
                <p className='text-[#475467] text-[12px] mb-[8px]'>Channels</p>
                <div className='flex'>
                  {channels}
                </div>
              </div>
            </div>
            <div className='w-[40%] pl-[40px]'>
              <div className='flex justify-between'>
                <div className='gap-y-[7px] grid grid-cols-4'>
                  <p className="text-[12px] text-[#475467] mb-[4px] col-span-2">Accepted Business Models</p>
                  <span className='col-span-2 flex gap-x-[4px]'>
                    <p className="text-[12px] text-[#475467] mb-[4px] mx-1">:</p>
                    <p className="text-[13px] font-[500] m-0">{details?.partner_key_terms?.acceptedBusinessModel}</p>
                  </span>


                  <p className="text-[12px] text-[#475467] mb-[4px] col-span-2">Trading Terms</p>
                  <span className='col-span-2 flex gap-x-[4px]'>
                    <p className="text-[12px] text-[#475467] mb-[4px] mx-1">:</p>
                    <p className="text-[13px] font-[500] m-0">{details?.partner_key_terms?.tradingTerms}</p>
                  </span>

                  <p className="text-[12px] text-[#475467] mb-[4px] col-span-2">Minimum Exclusivity Tenure</p>
                  <span className='col-span-2 flex gap-x-[4px]'>
                    <p className="text-[12px] text-[#475467] mb-[4px] mx-1">:</p>
                    <p className="text-[13px] font-[500] m-0">{details?.partner_key_terms?.exclusivityTenure}</p>
                  </span>

                  <p className="text-[12px] text-[#475467] mb-[4px] col-span-2">Marketing Investment</p>
                  <span className='col-span-2 flex gap-x-[4px]'>
                    <p className="text-[12px] text-[#475467] mb-[4px] mx-1">:</p>
                    <p className="text-[13px] font-[500] m-0">{details?.partner_key_terms?.marketingInvestment}</p>
                  </span>

                  <p className="text-[12px] text-[#475467] mb-[4px] col-span-2">Payment Terms</p>
                  <span className='col-span-2 flex gap-x-[4px]'>
                    <p className="text-[12px] text-[#475467] mb-[4px] mx-1">:</p>
                    <p className="text-[13px] font-[500] m-0">{details?.partner_key_terms?.paymentTerms}</p>
                  </span>
                </div>
                {type === USER_TYPE_PARTNER && details?.status === STATUS_PENDING && !statusDetails?.status ? (
                  <div className='flex flex-col gap-y-[8px]'>
                    <Button type='primary' onClick={() => confirmExpressInterest()}>Express Interest</Button>
                    <Button onClick={() => confirmSkipRequest()}>Skip</Button>

                  </div>
                ) : (<></>)}


              </div>


              <div className=' flex justify-between border-t border-[#E4E7EC] mt-[8px] pt-[16px]'>
                <div className="">
                  <p className="text-[14px] font-bold text-[#DC6803] mb-[8px]">{details?.counts?.suitable_count?.toString().padStart(2, "0")}</p>
                  <p className="text-[12px] text-[#667085] m-0">Suitable Partners</p>
                </div>
                <div className="">
                  <p className="text-[14px] font-bold text-[#175CD3] mb-[8px]">{details?.counts?.interested_count?.toString().padStart(2, "0")}</p>
                  <p className="text-[12px] text-[#667085] m-0">Interested Partners</p>
                </div>
                <div className="">
                  <p className="text-[14px] font-bold text-[#027A48] mb-[8px]">{details?.counts?.recommended_count?.toString().padStart(2, "0")}</p>
                  <p className="text-[12px] text-[#667085] m-0">Recommended Partners</p>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[8px] flex w-full  h-[calc(100vh-79px)] overflow-auto'>
            {type !== USER_TYPE_PARTNER ? (
              <div className='pl-[14px] pt-[14px]  w-[25%] border-r border-[#E4E7EC] pr-[8px]'>
                <p className='text-[13px] mb-[18px] font-[500]'>{type === USER_TYPE_ORGANIZATION ? "Interested Partners" : "Partners"}</p>
                {type === "admin" ? (
                  <Segmented
                    options={menuOptions}
                    onChange={(value) => {
                      onChangeMenu(value)
                    }}
                    value={selectedType}
                  />
                ) : (
                  <></>
                )}

                <div
                  id="scrollableDiv"
                  className='h-[calc(100vh-374px)] overflow-auto pr-[4px] mt-[20px]'
                >
                  <List
                    dataSource={partnerList}
                    loading={loadingPartners}
                    renderItem={(item, index) => (
                      <List.Item
                        key={index}
                        onClick={() => setSelectedPartner(item?.partner_id)}

                      >
                        <div className={`p-2 cursor-pointer hover:bg-blue-50 w-full rounded-1 transition-all duration-200 ${selectedParter === item?.partner_id ? "bg-blue-50" : ""}`}>
                          <PartnerItem data={item} />
                        </div>
                      </List.Item>

                    )}
                    locale={{
                      emptyText: (
                        <Empty description={selectedType === PARTNER_SUITABLE ? "No suitable partners" : "No interested partners"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      )
                    }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}

            <div
              className={`${type !== USER_TYPE_PARTNER ? 'w-[75%]' : "w-full"}`}
            >
              {selectedParter ? (
                <Tabs
                  items={items}
                  color='#12B76A'
                  className='h-full bg-tab bg-[#E9E9E9] !rounded-r-[8px] overflow-hidden'
                  animated
                  activeKey={activeTab}
                  onChange={(tab: string) => onChangeTab(tab)} />
              ) : (
                <div className='flex items-center flex-col justify-center h-[166px] mt-[100px]'>
                  <Empty description="No data" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>

              )}

            </div>
          </div>
        </div>
      )}

      <ConfirmModal
        open={Boolean(confirmModalData.type)}
        content={confirmModalData.message}
        onCancel={onCancelConfirm}
        onOk={onOkConfirm}
        okText={confirmModalData.okText}
        title={confirmModalData.title}
      />
      <FeedbackModal
        open={showFeedbackModal}
        onSuccess={() => setShowFeedbackModal(false)}
        onCancel={() => setShowFeedbackModal(false)}
        brandName={details?.brand?.brand_name || ""}
        partnerName={userProfile?.partnerv2?.name || ""}
      />
    </div>
  )
}

export default BrandRequestView